export default "__VITE_ASSET__d2bf7bdd__"